import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';
import API from 'api/API';
import { DeviceRepsRequestFilters } from 'api/models/DeviceReps';
import { QueryKeys } from 'api/models/QueryKeys';
import { useHasSurgeonsPermission } from 'hooks/useHasSurgeonsPermission';
import { useMemo } from 'react';

export const useDeviceReps = (params: DeviceRepsRequestFilters, enable = true) => {
  const { isAuthenticated } = useAuth0();
  const { data: hasSurgeonsPermission } = useHasSurgeonsPermission();
  const enabled = enable && isAuthenticated && hasSurgeonsPermission;

  const query = useQuery({
    queryKey: [QueryKeys.DeviceReps, params],
    queryFn: async () => API.deviceReps.getDeviceReps(params),
    enabled,
  });

  return useMemo(
    () => ({
      ...query,
      isLoading: enabled && query.isLoading,
    }),
    [enabled, query],
  );
};
